/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import {
  Component,
  OnInit,
  Output,
  OnChanges,
  Input,
  EventEmitter,
  ViewEncapsulation,
  ViewChild,
  SimpleChanges
} from '@angular/core';
import { NgForm } from '@angular/forms';
import {
  ChangeSponsorConfimationModalComponent
} from '../changesponsor/change-sponsor-confimation-modal.component';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../shared/services/common.service';
import { ChangeSponsorService } from '../changesponsor/change-sponsor.service';
import { AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-change-enroller',
  templateUrl: './change-enroller.component.html',
  styleUrls: ['../changesponsor/change-sponsor.component.scss'],
  providers: [ChangeSponsorService],
  encapsulation: ViewEncapsulation.None
})
export class ChangeEnrollerComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('sponsorForm') sponsorForm!: NgForm;
  @Output() closeSlider: EventEmitter<any> = new EventEmitter();
  @Input() sponsor: any;
  private globalDateFormatVar: any = localStorage.getItem('globalDateFormat');
  public datePickerOptions: Partial<BsDatepickerConfig> = {
    dateInputFormat: this.globalDateFormatVar
      ? this.globalDateFormatVar.toUpperCase()
      : 'MMM DD, YYYY',
      adaptivePosition: false,
      showTodayButton: true,
      todayPosition: 'center'
  };
  public sponsorPayload: any = {};
  public sponsorData: any = {};
  public validationObj = {
    userMessage: '',
    state: ''
  };
  public notificationOptions = {
    timeOut: 4000,
    showProgressBar: true,
    pauseOnHover: true,
    clickToClose: true,
    maxLength: 0,
    position: ['right', 'top']
  };
  public isEnrollerChanged = false;
  public currentEnroller: any;
  public newEnroller: any;
  public btnSubmit = true;
  public confResponse: any = {};
  public hasRequiredError = false;
  public isFormSubmitted = false;
  public defaultSearchText: any;
  public newEnrollerInactive = false;
  public participantInactive = false;
  public today = new Date();
  public enrollerLbl: any;
  private defaultConfig: ModalOptions = {
    backdrop: true,
    ignoreBackdropClick: true
  };
  public companyCode!: string;
  public recruiterChangeTypes = [
    { id: 1, name: "Change Recruiter" },
    { id: 2, name: "Remove Recruiter" }
  ];
  public selectedChangeType = '';


  constructor(
    public modalService: BsModalService,
    private toastr: ToastrService,
    public ChangeSponsorService: ChangeSponsorService,
    public commonService: CommonService,
    public translate: TranslateService,
    private cdr: ChangeDetectorRef
  ) {
    this.resetValidationErrorMessage();
    this.enrollerLbl=this.getTranslationWithKey('recruiter')
  }

  ngOnInit() {
    this.isEnrollerChanged = false;
    this.setEffectiveDate();
    this.resetValidationErrorMessage();
    this.companyCode = this.commonService.getCompanyCode();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['sponsor'] && changes['sponsor'].currentValue) {
      this.defaultSearchText = changes['sponsor'].currentValue?.clientId;
      this.fromClientSelected(changes['sponsor'].currentValue);
    }
  }

  ngAfterViewInit() {
    this.sponsorForm?.control?.valueChanges.subscribe((values) => {
      if (this.sponsorForm?.form?.invalid) {
        this.hasRequiredError = this.commonService.hasRequiredError(this.sponsorForm?.form?.controls);
      } else {
        this.isFormSubmitted = false;
        this.hasRequiredError = false;
      }
    });
  }

  public getTranslationWithKey(key: string) {
    return this.commonService.getTranslatedVal(key);
  }

  public setEffectiveDate() {
    this.sponsorPayload.effectiveDate = this.commonService.prepareBSDateObj(new Date().getTime());
  }

  public close() {
    this.isEnrollerChanged = false;
    this.closeSlider.emit();
  }

  public enrollerTypeChange() {
    if (this.sponsorPayload.client !== undefined) {
      this.currentEnroller = this.sponsorPayload.client.enroller;
      this.setFullName(this.currentEnroller);
    }
  }

  public onChangeGenealogyMoveType() {}

  public confimationPopUp() {
    const form = this.sponsorForm?.form;
    this.isFormSubmitted = true;
    this.hasRequiredError = false;
    this.newEnrollerInactive = false;
    this.participantInactive = false;
    if (form?.invalid || !this.hasValidFormData()) {
      this.hasRequiredError = this.commonService.hasRequiredError(form?.controls) || !this.hasValidFormData();
    } else if (
      this.sponsorPayload.client.status &&
      (this.sponsorPayload.client.status.code == 'INA' || this.sponsorPayload.client.status.code == 'SUS')
    ) {
      /*Participant Inactive/Suspended/None */
      this.participantInactive = true;
    } else if (
      this.sponsorPayload.toClient.status &&
      (this.sponsorPayload.toClient.status.code == 'INA' || this.sponsorPayload.toClient.status.code == 'SUS')
    ) {
      /*New Sponsor Inactive/Suspended/None */
      this.newEnrollerInactive = true;
    } else {
      this.isFormSubmitted = false;
      this.isEnrollerChanged = false;
      this.setFullName(this.sponsorPayload.client);
      this.setFullName(this.sponsorPayload.toClient);
      this.sponsorData['fromName'] = this.sponsorPayload.client.name;
      this.sponsorData['toName'] = this.sponsorPayload.toClient.name;
      this.sponsorData['type'] = this.sponsorPayload.enrollerType ? this.enrollerLbl : '';
      this.sponsorData['currentSponsor'] = this.currentEnroller; /*Current Enroller */
      this.sponsorData['newSponsor'] = this.newEnroller; /*New Enroller */
      const initialState = {
        context:{
          isFrom: 'EnrollerChange',
          data: this.sponsorData
        }
      };
      
      const modalRef: BsModalRef = this.modalService.show(ChangeSponsorConfimationModalComponent, {
        ...this.defaultConfig,
        initialState,
        class:'modal-dialog change-sponsor-reg-ter-modal'
      });
      
      // Handle modal close event
      modalRef.content?.closeModal.subscribe((result: any) => {
        if (result) {
          this.changeSponsorShip(result);
        }
      });
    }
  }

  private hasValidFormData() {
    if (this.selectedChangeType === 'Remove Recruiter' && ['TMPL', 'KSPL'].includes(this.companyCode)) {
      return true;
    }
    return this.sponsorPayload.client && (!this.sponsorPayload.enrollerType || this.sponsorPayload.toClient);
  }

  private setFullName(sponsor: any) {
    if (sponsor) {
      const firstName = sponsor.firstName || '',
        lastName = sponsor.lastName || '';
      sponsor.name = `${firstName} ${lastName}`;
    }
  }

  private resetValidationErrorMessage() {
    this.validationObj = {
      userMessage: '',
      state: ''
    };
  }

  public changeSponsorShip(result: any) {
    if (result === 'confirmed') {
      const payload = {
        sponsorType: this.sponsorPayload.enrollerType ? 'enroller' : '',
        comments: this.sponsorPayload.comments,
        effectiveDate: new Date().getTime()
      };
      let toClientId = null;
      if(['TMPL', 'KSPL'].includes(this.companyCode)) {
        toClientId = this.sponsorPayload.toClient.clientId ? this.sponsorPayload.toClient.clientId : null;
      } else {
        toClientId = this.sponsorPayload.toClient.clientId;
      }
      this.ChangeSponsorService.changeSponsor(
        payload,
        this.sponsorPayload.client?.clientId,
        toClientId
      ).then(this.successHandler.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
    }
  }

  private successHandler(result: any) {
    const res = result;
    this.confResponse = res;
    this.commonService.setUpdateChangeRecruiter({ message: 'Success', tabName: 'Genealogy' });
    this.resetValidationErrorMessage();
    this.isEnrollerChanged = true;
    this.toastr.success(this.getTranslationWithKey('operation_success'), this.getTranslationWithKey('success'));
  }

  public onStartDateChanged(event: Date) {}

  public fromClientSelected(event: any) {
    this.participantInactive = false;
    this.sponsorPayload.client = event;
    this.enrollerTypeChange();
  }

  public toEnrollerSelected(event: any) {
    this.newEnrollerInactive = false;
    this.sponsorPayload.toClient = event;
    if (this.sponsorPayload.toClient !== undefined) {
      this.newEnroller = this.sponsorPayload.toClient;
      this.setFullName(this.newEnroller);
    }
  }

  public clearDistributorSearch() {
    // capture before resetting
    const effDate = this.sponsorPayload.effectiveDate;
    this.currentEnroller = null;
    this.sponsorPayload = {};
    // reset to default value
    this.sponsorPayload.effectiveDate = effDate;
  }

  public onRecruiterChangeType(type: string): void {
    this.selectedChangeType = type;
    if (type === 'Remove Recruiter') {
      this.sponsorPayload.toClient = '';
      this.newEnroller = '';
    }
    this.cdr.detectChanges();
  }
}
